import React from "react";
import { Route, Link } from "react-router-dom";
import Order from "./Order";
import Paying from "./Paying";
import Car from "./Car";
import Family from "./Family";

const routes = [
  {
    id: "paying",
    dom: Paying,
  },
  {
    id: "order",
    dom: Order,
  },
  {
    id: "family",
    dom: Family,
  },
  {
    id: "car",
    dom: Car,
  },
];

interface Props {
  match: any;
}

const Index = (props: Props) => {
  const { match } = props;
  return (
    <React.Fragment>
      {routes.map(({ id, dom }) => {
        return (
          <Route exact key={id} path={`${match.url}/${id}`} component={dom} />
        );
      })}
    </React.Fragment>
  );
};

export default Index;
